
import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';
import { StudentsPerformance } from '@/models/Statistics';
export type StudentsPerformanceFilters = BaseFilters & {
  klassId?: number[];
  studentId?: number[];
  teacherId?: number[];
  unitId?: number[];
};
const baseUrl = 'analytics/students/performance/';
export const getStudentsPerformances = async (
  params: StudentsPerformanceFilters = {},
) => {
  const { data } = await requester().get<JsonApiResponse<StudentsPerformance>>(
    baseUrl,
    { params },
  );
  return data;
};